interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    id: 1,
    question: '香香漫画真的完全免费吗？',
    answer: '是的！香香漫画提供的所有漫画资源均为香香漫画大全免费阅读，无需任何付费订阅。您可以在香香漫画免费看全部内容，包括热门连载和经典完结作品。我们通过广告合作维持运营，确保读者能够持续享受免费的漫画阅读体验。',
  },
  {
    id: 2,
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是香香漫画的特色功能，让您像刷社交媒体一样阅读漫画。打开任意漫画后，只需向下滑动屏幕，内容就会自动连续加载，无需频繁点击"下一话"按钮。香香漫画免费下拉模式极大提升了追更体验，尤其适合一口气追完多话内容。',
  },
  {
    id: 3,
    question: '香香漫画的更新频率是怎样的？',
    answer: '香香漫画每日同步更新热门连载，确保您能看到最新话内容。热门作品通常与官方同步或延迟数小时内更新。香香漫画全集免费覆盖已完结作品，您可以一次性畅读完本。所有更新状态可以在漫画详情页和#updates模块中查看。',
  },
  {
    id: 4,
    question: '如何在手机上使用香香漫画？',
    answer: '您可以通过手机浏览器直接访问香香漫画网站，移动端页面已做完美适配，同样支持香香漫画免费下拉阅读。此外，我们也提供APP下载（详见#app模块），安装后可以享受更流畅的阅读体验、离线缓存、收藏同步等专属功能。',
  },
  {
    id: 5,
    question: '漫画画质和加载速度怎么样？',
    answer: '香香漫画采用高清图源，所有漫画图片经过专业压缩优化，在保证清晰度的同时实现快速加载。我们的服务器部署了CDN加速，无论您身在何处，下拉阅读都能流畅无卡顿。好看的漫画免费全集尽在香香漫画，画质与速度兼得。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">关于香香漫画，您想了解的都在这</p>
        </div>
        <div className="space-y-3">
          {faqs.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 shrink-0 mt-0.5">Q</span>
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed pl-7 md:pl-8">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}